import React from 'react'
import PropTypes from 'prop-types'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './TextLogo.scss'

/**
 * An insanely futuristic Labguard logo.
 */
const TextLogo = ({ color, withShadow, ...domProps }) => {
  color = getColor(color)

  return (
    <svg {...mergeProps()({ className: styles.logo }, domProps)} viewBox="0 0 545.56 75.64">
      <defs>
        <filter id="brand-inset-shadow">
          <feOffset dx="0" dy="1" />
          <feGaussianBlur stdDeviation="1" result="offset-blur" />
          <feComposite operator="out" in="SourceGraphic" in2="offset-blur" result="inverse" />
          <feFlood floodColor="black" floodOpacity="0.33" result="color" />
          <feComposite operator="in" in="color" in2="inverse" result="shadow" />
          <feComposite operator="over" in="shadow" in2="SourceGraphic" />
        </filter>
      </defs>
      <title>Labguard</title>
      <g id="brand" filter={withShadow ? 'url(#brand-inset-shadow)' : ''}>
        <path fill={color} d="M0,74.27V1.38H8.67v65H43.73v7.88Z" />
        <path
          fill={color}
          d="M50.23,74.27,76,1.08h9.06L110.9,74.27h-9L94.75,53.38h-29L58.6,74.27ZM68.45,45.8H92.09L80.47,11.62h-.2Z"
        />
        <path
          fill={color}
          d="M123,74.27V1.38h26.1C165,1.38,174,7.49,174,19.6c0,9.95-6,15.27-13.49,16.84v.2c9,1.67,15.86,7.09,15.86,17.73,0,12.21-9.06,19.9-25.21,19.9Zm8.57-41.07h16.74c10.93,0,17.24-3.84,17.24-12.21s-5.22-11.92-17-11.92H131.58Zm0,33.49h19c11.92,0,17.24-4.53,17.24-12.9,0-9.16-7.29-13.1-19-13.1H131.58Z"
        />
        <path
          fill={color}
          d="M187,37.53C187,14.38,199.83,0,218.05,0c13.79,0,23.15,7.29,27,22.56L237,24.62C233.52,12.9,228.1,8,218,8c-11.43,0-22.16,8.77-22.16,29.25s9.55,30.63,22.46,30.63c11.33,0,19-7.68,19.21-21.18H220.71V39.4h25.12V74.27h-7.58V63.33H238c-2.86,6-9.26,12.31-20.59,12.31C197.76,75.64,187,59.59,187,37.53Z"
        />
        <path
          fill={color}
          d="M260.8,49.05V1.38h8.67V47.87c0,11.72,5.61,19.9,18.52,19.9,12.71,0,18.32-7.88,18.32-19.7V1.38h8.57V48.85c0,15.17-9,26.69-27,26.69C269.17,75.55,260.8,64.12,260.8,49.05Z"
        />
        <path
          fill={color}
          d="M323.53,74.27,349.34,1.08h9.06l25.81,73.18h-9l-7.19-20.88h-29l-7.19,20.88ZM341.76,45.8h23.64L353.77,11.62h-.2Z"
        />
        <path
          fill={color}
          d="M396.32,74.27V1.38h25c16.55,0,25.9,7,25.9,20.39,0,11.72-6.6,17.83-16.94,20l17.93,32.5h-9.46L421.33,42.85H404.89V74.27Zm8.57-39.1h16c11.43,0,17.83-3.15,17.83-13.1,0-9.55-6.3-12.8-17.93-12.8H404.89Z"
        />
        <path
          fill={color}
          d="M463,74.27V1.38H482.2c23.44,0,36.74,11.82,36.74,36.25,0,24.72-13.59,36.64-36.74,36.64Zm8.67-7.78h11.62c17.63,0,27-8.57,27-28.86,0-19.6-9.46-28.27-27.18-28.27H471.66Z"
        />
        <path
          fill={color}
          d="M526.17,10.29a9.7,9.7,0,1,1,19.39,0,9.7,9.7,0,1,1-19.39,0Zm18,0a8.29,8.29,0,1,0-16.58,0,8.29,8.29,0,1,0,16.58,0ZM532.26,4.71h3.82c2.48,0,3.86,1.09,3.86,3.11a2.79,2.79,0,0,1-2.27,3l2.56,4.7h-1.8L536,11h-2.06V15.5h-1.68ZM536,9.62c1.43,0,2.31-.42,2.31-1.72s-.88-1.68-2.35-1.68h-2v3.4Z"
        />
      </g>
    </svg>
  )
}

TextLogo.defaultProps = {
  color: 'primary',
}

TextLogo.propTypes = {
  /**
   * The text color.
   */
  color: PropTypes.string,
  /**
   * Whether to show the inner shadow.
   */
  withShadow: PropTypes.bool,
}

export default TextLogo
